import { useNavigate } from "react-router-dom";
import { useStickerSectionStore } from "../MugEditorFeature/EditorStore";

export default function PreviewPage() {
    const navigate = useNavigate();
    const previewImageLinks = useStickerSectionStore((state) => state.previewImageLinks);

    const mockupUrl = previewImageLinks[0] || null;

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "#7a9a9a",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                color: "#f4f8f8",
                fontFamily: "'Quicksand', sans-serif",
                overflow: "hidden",
            }}
        >
            <button
                onClick={() => navigate(-1)}
                style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "transparent",
                    border: "none",
                    fontSize: "2rem",
                    cursor: "pointer",
                    color: "#f4f8f8",
                    fontWeight: "bold",
                    zIndex: 10,
                    padding: "10px",
                }}
                aria-label="Close preview"
            >
                ✕
            </button>

            {mockupUrl ? (
                <img
                    src={mockupUrl}
                    alt="Product mockup"
                    style={{
                        maxHeight: "90%",
                        maxWidth: "90%",
                        borderRadius: "10px",
                        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                    }}
                />
            ) : (
                <div style={{ color: "#f4f8f8", fontSize: "1.5rem" }}>
                    No preview available
                </div>
            )}
        </div>
    );
}
